// extracted by mini-css-extract-plugin
export var exchangeRateDisclaimer = "CruiseHeaderDisclaimer-module--exchange-rate-disclaimer--d6f57";